import { createGlobalStyle } from 'styled-components';
import { colors } from '../theme/colors';
import { psudoSkeletonStyles } from './psudoSkeleton';

export const GlobalStyles = createGlobalStyle`
  html {
    font-size: 62.5%;
    font-display: swap;
    box-sizing: border-box;
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }
  *:focus {
    outline: none;
  }

  body {
    font-family: "Roboto", Geneva, Verdana, sans-serif;
    color: ${colors.kilamanjaro};
    background: ${colors.white};
    font-weight: 400;
    padding: 0;
    margin: 0;
    font-size: 1.2rem; /* =12px */
    line-height: 1.42857; /* ~18px */
    max-width: 100vw;
    overflow-x: hidden;
  }
  a {
    text-decoration: none;
  }

  img {
    user-select: none;
  }

  strong {
    font-weight: 700;
  }

  svg {
    fill: currentColor;
  }
  

  .slider > .slider-frame > .slider-list {
    width: auto !important;
  }

  .slider {
    height: auto !important;
  }
   * {
    -webkit-tap-highlight-color: transparent
   };

  .ReactCollapse--collapse {
      transition: height 500ms;
  }
  #uc-main-banner > div.uc-banner-content {
    background-color: ${colors.kilamanjaro} !important;
  }

  #uc-main-banner #uc-banner-text {
    color: ${colors.white} !important;
  }

   ${psudoSkeletonStyles}

   .uc-client__banner {
     z-index: 101;
   }

   .uc-modal {
     z-index: 1001;
   }
`;
